<template>
  <p class="card-body" v-html="body" />
</template>

<script lang="ts">
export default {
  name: 'CardBodyLine',
  props: {
    body: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.card-body {
  color: #000;
  text-align: center;
  /* Body text/Body | Default */
  font-family: Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  margin: 0;
  padding: 0;
}
</style>
